import {styled} from "@mui/material/styles";

export const Container = styled('div')(() => ({
    padding: '20px',
    width: '100%',
}));